import React from 'react';
import SectionHeader from '../components/ui/SectionHeader';
import Badge from '../components/ui/Badge';

export default function Commercial() {
  return (
    <section>
      <SectionHeader id="commercial" title="11-16. Commercial & Deal Desk" subtitle="Pricing, ROI, and the No-Free-Trial policy." />
      
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-8">
        <div className="bg-red-900/20 border border-red-500/30 p-6 rounded-xl">
          <h3 className="text-xl font-bold text-red-500 mb-2 underline">No Free Trials</h3>
          <p className="text-slate-300 text-sm mb-4">
            We do not offer free trials. This is a non-negotiable commercial stance due to the high variable costs of our data feeds and editorial production.
          </p>
          <div className="bg-slate-900/50 p-4 rounded text-xs text-slate-300 border border-red-500/20">
            <strong>Handling the "Trial" request:</strong><br/>
            "Because we carry significant ongoing costs for both technology and content delivery, we don't offer free trials. However, we're completely transparent—you can monitor our live output anytime at thepitchfeed.com/news to verify quality before we sign."
          </div>
        </div>

        <div className="bg-amber-900/20 border border-amber-500/30 p-6 rounded-xl">
          <h3 className="text-xl font-bold text-amber-500 mb-2">Pricing Guidance</h3>
          <p className="text-slate-300 text-sm mb-4">
            Pricing is volume and traffic dependent. Verify internally before delivering any formal quote.
          </p>
          <ul className="text-xs text-slate-400 space-y-1">
            <li>• Confirm # of news stories required.</li>
            <li>• Confirm # of languages.</li>
            <li>• Confirm website traffic (for Widget pricing).</li>
          </ul>
        </div>
      </div>

      <div className="bg-slate-800 p-6 rounded-xl border border-slate-700">
        <h3 className="text-lg font-bold text-white mb-4">ROI Framing</h3>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div className="p-4 bg-slate-900 rounded-lg">
            <span className="text-blue-400 font-bold block mb-1">Scale</span>
            <p className="text-xs text-slate-400 italic">"You get 40+ stories/day instantly. Hiring a team to do that costs $15k+/month minimum."</p>
          </div>
          <div className="p-4 bg-slate-900 rounded-lg">
            <span className="text-emerald-400 font-bold block mb-1">Engagement</span>
            <p className="text-xs text-slate-400 italic">"ScoreWidget increases time-on-page. Every extra minute is a potential ad refresh."</p>
          </div>
          <div className="p-4 bg-slate-900 rounded-lg">
            <span className="text-purple-400 font-bold block mb-1">Focus</span>
            <p className="text-xs text-slate-400 italic">"Let your star writers focus on analysis; let us handle the routine daily match news coverage."</p>
          </div>
        </div>
      </div>
    </section>
  );
}